module.exports = __webpack_public_path__ + "static/intra_fct2-dd4706f7157f5d886f4e0de93ce27724.jpg";